import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Initialize Firestore
export const db = getFirestore(app);

// Connect to emulators in development (only if explicitly enabled)
// Set REACT_APP_USE_EMULATORS=true in .env.local to use emulators
if (window.location.hostname === 'localhost' && process.env.REACT_APP_USE_EMULATORS === 'true') {
  console.log('🔧 Using Firebase Emulators');
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
} else if (window.location.hostname === 'localhost') {
  console.log('🔥 Local development using LIVE Firebase (production database)');
}

// Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Force account selection
googleProvider.setCustomParameters({
  prompt: 'select_account', // Always show account picker
});

export default app;
